import { Pipe, PipeTransform } from '@angular/core';
import { ContentService } from '../../services/content/content.service';
import { Models } from '@ibexfusion/models';

@Pipe({
  name: 'contentGallery'
})
export class GalleryPipe implements PipeTransform {

  constructor(private contentService: ContentService) {
  }

  transform(entry: Models.ContentEntry): Models.GalleryEntry {
    if (!entry || (!entry.files && !entry.related)) {
      return null;
    }

    const gallery = new Models.GalleryEntry();

    gallery.populateFromJSON({
      sourceId: entry._id,
      title: entry.title,
      description: entry.detail && entry.detail.description ? entry.detail.description : null,
      media: this.contentService.getMediaEntriesForEntry(entry.getId()).length !== 0 ?
        this.contentService.getMediaEntriesForEntry(entry.getId()) : []
    });

    const docs = (entry.files && entry.files.length > 0 ?
      this.contentService.getDocumentEntriesForEntry(entry.getId()) : []);

    for (const doc of docs) {
      doc.url = doc.url + '.' + doc.extension;
    }
    gallery.documents = docs;

    return gallery;
  }

}
